module.exports = __webpack_public_path__ + "static/img/back-marketplace.1ca1822.jpg";